import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";
import { Animation } from "@nocios/presentation-kit";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";

const PageId = 7;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  const DATA_IMAGES = [
    {
      image: `${baseImageUrl}animation_0.png`,
      effect: "animate-opacity",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
    {
      image: `${baseImageUrl}animation_1.png`,
      effect: "animate-opacity",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
    {
      image: `${baseImageUrl}animation_2.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
    {
      image: `${baseImageUrl}animation_3.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
    {
      image: `${baseImageUrl}animation_4.png`,
      effect: "animate-up",
      imageStyle: { width: "var(--width-1920)", right: 0, top: 0 },
    },
  ];

  const times = [600, 500, 500, 500, 500, 600];

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    gradient: `linear-gradient(268deg, rgba(10, 45, 101, 0.00) 28.65%, #000000 97.16%), linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%)`,
    title: "Enhanced Parental Controls",
    description: `Empower families with robust tools to create a\nsafe and secure internet environment for their\nloved ones. The platform’s advanced features\ngive parents full control and peace of mind.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`Key Features:<ul>\n<li>Time Management: Set daily or weekly time\nlimits for internet usage across devices.</li>\n<li>Content Filtering: Automatically block\ninappropriate websites and apps based on\ncustomizable settings.</li>\n<li>Personalized Profiles: Create tailored user\nprofiles for each family member with unique\ncontrols and preferences.</li></ul>`}
      />
    ),
    rightSideComponent: <Animation times={times} pageNumber={PageId} currentPage={currentPage} images={DATA_IMAGES} />,

    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
